module.exports = __webpack_public_path__ + "img/default_user.616fcc9d.png";